module.exports = __webpack_public_path__ + "img/empreendimento-logo-39.36b8199e.png";